import { styled } from '@mui/material/styles'

const BrandName = styled('div', {
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'revers',
    name: 'MosaicGuardians',
    slot: 'value',
  })(({ theme, open, revers=false }) => ({
    ...theme.typography.h7,
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    
    color: 'white',
    overflowX: 'hidden',
    width: 'fit-content',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create(['opacity'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          width: revers?0:'fit-content',
        }
      },
      {
        props: ({ open }) => !open,
        style: {
          transition: theme.transitions.create(['opacity'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }
      },
      {
        props: ({ revers }) => revers,
        style: {
          opacity: open?0:1,
        }
      },
      {
        props: ({ revers }) => !revers,
        style: {
          opacity: open?1:0,
          // marginLeft: 20,

        }
      },
    ]
  }));

  export default BrandName;